module.exports = __webpack_public_path__ + "img/s2P24.c79de8ac.png";